import { useParams } from "react-router-dom";
import type { FeatureRouteParams } from "types/navigation";

export function useFeatureRouteParams() {
  return useParams<FeatureRouteParams>();
}
